import React from 'react'
import { LOGO_ASSETS, LogoVariant } from '../assets'

export interface LogoProps {
  /** Logo variant to display */
  variant?: LogoVariant
  /** Size preset or custom height class */
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string
  /** Additional CSS classes */
  className?: string
  /** Alt text for accessibility */
  alt?: string
  /** Use white variant for dark backgrounds */
  onDark?: boolean
}

const sizeMap = {
  xs: 'h-4',   // 16px
  sm: 'h-6',   // 24px
  md: 'h-8',   // 32px
  lg: 'h-12',  // 48px
  xl: 'h-16',  // 64px
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'full',
  size = 'md',
  className = '',
  alt = 'TalkToast',
  onDark = false,
}) => {
  // Select appropriate logo based on background
  const logoSrc = onDark && variant === 'full'
    ? LOGO_ASSETS.fullWhite
    : LOGO_ASSETS[variant]

  // Handle size prop - use preset or custom class
  const sizeClass = size in sizeMap ? sizeMap[size as keyof typeof sizeMap] : size

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={`w-auto ${sizeClass} ${className}`}
      loading="lazy"
    />
  )
}

// Convenience exports for common use cases
export const LogoFull = (props: Omit<LogoProps, 'variant'>) => (
  <Logo variant="full" {...props} />
)

export const LogoIcon = (props: Omit<LogoProps, 'variant'>) => (
  <Logo variant="icon" {...props} />
)
